<template>
    <v-sheet>
        <v-toolbar dense class="mb-3 secondary" elevation="1" rounded>
            <v-breadcrumbs large :items="[
                { text: 'Sales and Distribution' },
                { text: 'Reports' },
                { text: 'Customer Statement Report' },
            ]"> </v-breadcrumbs>
        </v-toolbar>
        <v-sheet elevation="1" rounded>
            <v-toolbar flat class="secondary">
                <v-toolbar-title v-if="data">
                    {{data.customer_code}} - {{data.customer_name}} - Statement
                </v-toolbar-title>
                <v-toolbar-title v-else>
                    Customer Statement Report
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <div class="mx-4" v-if="data">
                    <v-chip>{{this.from}}</v-chip>
                    <span class="mx-2">to</span>
                    <v-chip>{{this.to}}</v-chip>
                </div>
                <v-divider vertical v-if="data"></v-divider>
                <v-toolbar-items>
                     <v-btn icon v-if="data" @click="get" :loading="loading">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn depressed color="primary" @click="searchDialog = true">
                        <v-icon left>mdi-magnify</v-icon>
                        search
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
            <CustomerStatementTable :statement="data" v-if="data" :loading="loading"/>
            <div v-else class="text-center pa-4">
                <div>Please Search for Customer Statement</div>
            </div>
        </v-sheet>
        <v-dialog v-model="searchDialog" width="500" persistent>
            <v-card>
                <v-card-title>
                    Search Statement
                </v-card-title> 
                <v-card-text>
                    <v-form ref="form">
                        <v-row>
                            <v-col>
                                <v-autocomplete
                                    label="Customer"
                                    outlined
                                    :rules=[isRequired]
                                    dense
                                    v-model="form.customer_id"
                                    :items="customers"
                                    :loading="customersloading"
                                    item-text="display_name"
                                    item-value="id"
                                    hide-details="auto"
                                    @update:search-input="searchCustomers"
                                    clearable
                                    >
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <PDatePicker
                                    label="from"
                                    v-model="form.from"
                                    outlined
                                    hide/>
                            </v-col>
                            <v-col>
                                <PDatePicker
                                    label="to"
                                    outlined
                                    v-model="form.to"
                                    hide/>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-row no-gutters>
                        <v-col class="me-1">
                            <v-btn block depressed color="primary" @click="submit" :loading="loading">
                                submit
                            </v-btn>
                        </v-col>
                        <v-col class="ms-1">
                            <v-btn block text color="primary" @click="searchDialog = false">
                                cancel
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">{{snackbar.text}}</v-snackbar>
    </v-sheet>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import CustomerStatementTable from './../../components/Sales/CustomerStatementTable.vue';
import PDatePicker from './../../components/common/PDatePicker';
import { isRequired } from './../../utils/validations';
import moment from 'moment';

export default {
    name: "CustomerStatementView",
    components: {
        CustomerStatementTable,
        PDatePicker
    },
    data() {
        return {
            searchDialog: false,
            form: {
                customer_id: null,
                from: moment().startOf("year").format("YYYY-MM-DD"),
                to: moment().format("YYYY-MM-DD")
            },
            snackbar: {
                value: false,
                text: "",
                color: ""
            }
        }
    },
    computed: {
        ...mapGetters("sales/reports/customerStatement", [
            "data", "from", "to", "loading"
        ]),
        ...mapGetters("sales/customer/search", {
            customers: "list",
            customersloading: "loading"
        })
    },
    methods: {
        ...mapActions("sales/reports/customerStatement", [
            "updateParams", "get"
        ]),
        ...mapActions("sales/customer/search", {
            searchCustomers: "get"
        }),
        isRequired,
        async submit() {
            if(!this.$refs.form.validate()) return;
            this.run();
        },
        run() {
            
            this.updateParams(this.form).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar = { value: true, color: "error", text: message }
            }).finally(() => {
                this.searchDialog = false;
            });
        }
    },
    mounted() {
        if(this.$route.query.customer_id) {
            this.form.customer_id = this.$route.query.customer_id;
            this.run();
        }
    }
}
</script>